import React from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { KENYA_ADMIN_MAP } from "../../constants/siteContent";
import { fadeInUp, staggerContainer } from "../../lib/animations";

export const HeroSection = () => {
  return (
    <section data-testid="hero-section" className="relative min-h-screen overflow-hidden bg-[#F5F1E8] pt-20">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src={KENYA_ADMIN_MAP}
          alt="Kenya administrative boundaries map"
          className="absolute inset-0 h-full w-full object-contain object-[58%_center] scale-[1.18] md:scale-[1.34] opacity-58"
          data-testid="hero-map-image"
        />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.72),rgba(255,255,255,0.34)_44%,rgba(255,255,255,0.58)),radial-gradient(circle_at_top_right,rgba(209,17,26,0.10),transparent_35%)]" />
      </div>

      <div className="relative z-10 mx-auto flex min-h-[calc(100vh-5rem)] w-full max-w-7xl items-center justify-start px-6 py-16">
        <motion.div
          className="max-w-2xl border border-white/78 bg-white/68 px-7 py-8 text-left shadow-[0_20px_70px_rgba(10,10,10,0.10)] backdrop-blur-sm md:px-10 md:py-9"
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
        >
          <motion.p variants={fadeInUp} className="mb-4 text-sm font-semibold uppercase tracking-[0.3em] text-[#D1111A]">
            Strategic Plan 2022-2027
          </motion.p>

          <motion.h1
            variants={fadeInUp}
            className="font-editorial mb-6 text-5xl leading-[0.95] text-[#0A0A0A] md:text-7xl lg:text-8xl"
            data-testid="hero-title"
          >
            It&apos;s All About The
            <br />
            <span className="italic text-[#D1111A]">Youth & Community</span>
          </motion.h1>

          <motion.p variants={fadeInUp} className="max-w-md text-xs leading-relaxed text-[#0A0A0A]/70 md:text-sm" data-testid="hero-supporting-text">
            Kenya Premier League vision, community football growth, and commercial restructure, rebrand and reposition for the future of the game.
          </motion.p>

          <motion.div variants={fadeInUp} className="mt-10">
            <a
              href="#vision"
              className="inline-flex items-center gap-2 text-[#0A0A0A]/75 hover:text-[#D1111A] transition-colors"
              data-testid="hero-explore-link"
            >
              <span className="text-sm uppercase tracking-widest">Explore</span>
              <ChevronDown className="animate-bounce" size={20} />
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};